<div class="login-wrap">
  <cigna-alerts [alert]="loginAlert$ | async"></cigna-alerts>
  <cigna-login-message [params]="queryParams$ | async"></cigna-login-message>
  <div class="login-image-cover">
    <cigna-login-form [params]="queryParams$ | async"></cigna-login-form>
  </div>
</div>
<div class="cg-clearfix content-rail">
  <cigna-quick-access-links></cigna-quick-access-links>
  <cigna-cigna-resources></cigna-cigna-resources>
</div>
